import { createSelector } from 'reselect';
import _ from 'lodash';

const DetailCompanyOrganizerSelector = {
    createDetailCompanyOrganizerResultsSelector: () => createSelector([
        (state) => state.companyManagementOrganizer.detailCompanyOrganizer.data.company,
        (state) => state.companyManagementOrganizer.detailCompanyOrganizer.data.user,
        (state) => state.companyManagementOrganizer.detailCompanyOrganizer.data.seminars,
        (state) => state.companyManagementOrganizer.detailCompanyOrganizer.data.live_stream,
    ], (company, user, seminars, live_stream) => {
        if (!_.isEmpty(company) && !_.isEmpty(user)) {
            return {
                idCompany: company.id,
                idUser: company.user,
                fullName: company.full_name,
                fullNameEN: company?.full_name_en,
                shortName: company.short_name,
                shortNameEN: company?.short_name_en,
                companyType: company.company_type,
                companyCategory: company.companyCategory,
                image: company.image,
                department: user.department,
                url: company.url,
                position: user.position,
                location: user.location,
                address: user.address,
                addressEN: user.address_en,
                email: user.email,
                phoneNumber: user.phone_number,
                faxNumber: user.fax_number,
                firstName: user.first_name,
                lastName: user.last_name,
                description: company.description,
                descriptionEN: company.description_en,
                zipCode: user.zip_code,
                organizerBooth: user.organizer_booth,
                register_ads_max: company.register_ads_max,
                seminars,
                employee_number: user.employee_number,
                occupation_name: user.occupation_name,
                zone: user.zone,
                has_payment: company.payment_method,
                live_stream,
            };
        }
        return {};
    }),
};

export default DetailCompanyOrganizerSelector;
